export const getUnselectedCountries = (countries, allGroups, ignoreGroupId) => {
    const unassignedCountries = countries.map((c) => c.code);
    return allGroups.reduce((accumulator, currentGroup) => {
        if (currentGroup.id === ignoreGroupId) {
            return accumulator;
        }
        const unselectedCountries = accumulator.filter((country) => !currentGroup.selectedCountries.includes(country));
        return unselectedCountries;
    }, unassignedCountries);
};
